import React, { useContext } from 'react'
import { IonButtons, IonHeader, IonIcon, IonNavLink, IonRouterLink, IonTitle, IonToolbar } from '@ionic/react'
import { arrowBackOutline, bookmark, bookmarkOutline, notifications, close } from 'ionicons/icons'
import styled from 'styled-components'
import { TextStyle } from '../../atoms'
import { useHistory } from 'react-router'
import { StoresContext } from '../../../provider/StoreProvider'
import { observer } from 'mobx-react'

type Props = {
  type: 'MAIN' | 'SUB' | 'MODAL' | 'NAV'
  title: string
  rightItem?: 'FAVORITE_ON' | 'FAVORITE_OFF' | 'ALARM'
  subTitle?: string
  onDismiss?: () => void
  href?: string
}
const rightIconMap = {
  FAVORITE_ON: bookmark,
  FAVORITE_OFF: bookmarkOutline,
  ALARM: notifications,
}

export const StyleIonHeader: React.FC<Props> = observer(({ type, title, subTitle, onDismiss, rightItem, href }) => {
  const { authStore, notificationStore } = useContext(StoresContext)
  const history = useHistory()
  const unreadCount = notificationStore.unreadNotification?.result

  return (
    <>
      <IonHeader>
        <StyleToolbar>
          {type === 'MAIN' && (
            <>
              <TextStyle type={'b_24'} style={{ paddingLeft: '18px' }}>
                {title}
              </TextStyle>
              <IonButtons slot="end">
                {title != 'SIGNIN' && !authStore.userInfo && (
                  <IonRouterLink color={'dark'} routerLink="/signIn">
                    <TextStyle type={'r_13'} style={{ paddingRight: '5px' }}>
                      {'로그인'}
                    </TextStyle>
                  </IonRouterLink>
                )}
                <NotificationContainer>
                  <IonRouterLink href="/notification">
                    {unreadCount != null && unreadCount > 0 && <StyleBadge />}
                    {rightItem != null && <IonIcon color="dark" icon={rightIconMap[rightItem]} />}
                  </IonRouterLink>
                </NotificationContainer>
              </IonButtons>
            </>
          )}
          {type === 'SUB' && (
            <>
              <IonButtons slot="start" onClick={href ? () => history.push(href) : () => history.goBack()}>
                <IconContainer>
                  <IonIcon icon={arrowBackOutline} color={'dark'} />
                </IconContainer>
              </IonButtons>
              <IonTitle style={{ textAlign: 'center' }}>{title}</IonTitle>
              <IonButtons slot="end">
                {rightItem != null && <IonIcon color="dark" icon={rightIconMap[rightItem]} />}
                <TextStyle type={'m_13'} color={'primary_light'} style={{ paddingRight: '18px' }}>
                  {subTitle}
                </TextStyle>
              </IonButtons>
            </>
          )}
          {type === 'MODAL' && (
            <>
              <IonButtons slot="start" onClick={onDismiss}>
                <IconContainer>
                  <IonIcon icon={close} color={'dark'} />
                </IconContainer>
              </IonButtons>
              <IonTitle>{title}</IonTitle>
              <IonButtons slot="end">
                {rightItem != null && <IonIcon color="dark" icon={rightIconMap[rightItem]} />}
                <TextStyle type={'m_13'} color={'primary_light'} style={{ paddingRight: '18px' }}>
                  {subTitle}
                </TextStyle>
              </IonButtons>
            </>
          )}
          {type === 'NAV' && (
            <>
              <IonButtons slot="start">
                <IonNavLink routerDirection="back">
                  <IconContainer>
                    <IonIcon icon={arrowBackOutline} color={'dark'} />
                  </IconContainer>
                </IonNavLink>
              </IonButtons>
              <IonTitle>{title}</IonTitle>
              <IonButtons slot="end">
                {rightItem != null && <IonIcon color="dark" icon={rightIconMap[rightItem]} />}
                <TextStyle type={'m_13'} color={'primary_light'} style={{ paddingRight: '18px' }}>
                  {subTitle}
                </TextStyle>
              </IonButtons>
            </>
          )}
        </StyleToolbar>
      </IonHeader>
    </>
  )
})

const StyleToolbar = styled(IonToolbar)`
  --background: var(--ion-color-white);
  --min-height: 45px;
  ion-title {
    padding: 0 0 0 5px;
  }
  ion-icon {
    font-size: 24px;
  }
`

const IconContainer = styled.div`
  margin-left: 13px;
  padding-top: 7px;
  cursor: pointer;
`

const NotificationContainer = styled.div`
  position: relative;
  width: 30px;
  margin-right: 11px;
  top: 4px;
`

const StyleBadge = styled.div`
  position: absolute;
  background-color: red;
  border-radius: 10px;
  width: 6px;
  height: 6px;
  left: 25px;
  bottom: 25px;
  z-index: 10;
`
